import React from 'react'

const WordCount = ({ word, limit }: { word: string; limit: number }): JSX.Element => (
  <span style={{ float: 'right' }}>
    ({word?.length || 0} / {limit})
  </span>
)

export default WordCount
